import { Component, Input, OnInit, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { NotificationSettingsService } from "@app/mailmessages/service/notification-settings.service";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { IdNameCombination } from "@models/generic/IdNameCombination";
import { BaseUserModel } from "../models/base-user-model";
import { firstValueFrom } from "rxjs";
import { TranslatePipe, injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/user/i18n/scope";
import { CerrixLoaderComponent } from "@app/shared/components/cerrix-loader/cerrix-loader.component";
import { CerrixSelectComponent } from "@app/shared/cerrix-select/cerrix-select.component";

@Component({
    selector: "user-notification-settings",
    templateUrl: "./user-notification-settings.component.html",
    styleUrls: ["./user-notification-settings.component.scss"],
    imports: [FormsModule, CerrixLoaderComponent, CerrixSelectComponent, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class UserNotificationSettingsComponent implements OnInit {
    private settingsService = inject(NotificationSettingsService);
    private toastr = inject(ToastrService);
    private _translation = injectTranslation(scope);

    @Input() parentTab: TabModel;
    @Input() userModel: BaseUserModel;
    @Input() showSave: boolean = true;

    notificationOptions: IdNameCombination[] = [{ ID: 1, Name: "Email" }];
    // Translation key; the template translates it.
    slackStatusKey: string = "notificationSettings.slackNotConnected";

    async ngOnInit() {
        if (!this.parentTab.showLoader) {
            this.parentTab.showLoader = true;
        }

        if (this.userModel.linkedToSlack) {
            this.notificationOptions = [
                { ID: 1, Name: "Email" },
                { ID: 2, Name: "Slack" },
                { ID: 3, Name: "Both" },
            ];

            this.slackStatusKey = "notificationSettings.slackConnected";
        }

        this.parentTab.showLoader = false;
    }

    async saveNotificationPreference() {
        await firstValueFrom(
            this.settingsService.storePreference(
                this.userModel.guid,
                this.userModel.notificationPreference
            )
        );
        await this._translation.ready();
        this.toastr.success(this._translation.t("notificationSettings.preferenceSaved"));
    }

    async syncUser() {
        await firstValueFrom(this.settingsService.syncUser(this.userModel.guid));
        await this._translation.ready();
        this.toastr.success(this._translation.t("notificationSettings.userSynced"));
    }
}
